import { Component, OnInit, OnDestroy } from '@angular/core';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { ActivatedRoute } from '@angular/router';
import { EMPTY, Subscription } from 'rxjs';
import { BroadcastingsService } from 'src/app/services/broadcastings-services/broadcastings.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators/catchError';

@Component({
  selector: 'app-broadcastings-tv-format-dashboard',
  templateUrl: './broadcastings-tv-format-dashboard.component.html',
  styleUrls: ['./broadcastings-tv-format-dashboard.component.scss']
})
export class BroadcastingsTvFormatDashboardComponent implements OnInit, OnDestroy {

  tvFormatDeviceInfo;
  tvFormatShapes;
  tvFormatDesks;
  refreshTvFormatSubscription: Subscription;
  getTvFormatDeviceInfoSubscription: Subscription;
  getTvFormatLayoutsSubscription: Subscription;
  getTvFormatDesksSubscription: Subscription;

  constructor(private broadcastingsService: BroadcastingsService,
              private activatedRoute: ActivatedRoute,
              private snackbarService: SnackBarService,
              private headerBreadcrumbService: HeaderBreadcrumbService) { }

  ngOnInit() {
    this.refreshTvFormatSubscription = this.broadcastingsService.refreshTvFormatListen().subscribe(
      (res) => {
        this.getTvFormatShapes();
        this.getTvFormatDesks();
        this.getBroadcastingInfo();
      }
    );
    this.getBroadcastingInfo();
    this.getTvFormatShapes();
    this.getTvFormatDesks();
    this.setBreadcrumb();
  }

  private getBroadcastingInfo() {
    const internalId = this.activatedRoute.snapshot.params['tvformatid'];
    this.getTvFormatDeviceInfoSubscription = this.broadcastingsService.getTvFormatDeviceInfo(internalId).pipe(
      tap(o => this.tvFormatDeviceInfo = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getTvFormatShapes() {
    const internalId = this.activatedRoute.snapshot.params['tvformatid'];
    this.getTvFormatLayoutsSubscription = this.broadcastingsService.getTvFormatLayouts(internalId).pipe(
      tap(o => this.tvFormatShapes = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private getTvFormatDesks() {
    const internalId = this.activatedRoute.snapshot.params['tvformatid'];
    this.getTvFormatDesksSubscription = this.broadcastingsService.getTvFormatDesks(internalId).pipe(
      tap(o => this.tvFormatDesks = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-th-large', 'broadcastings-page.tvformat detail', '/broadcastings/tvformats', [new BRoute('broadcastings-page.broadcastings', '/broadcastings'), new BRoute('broadcastings-page.tvformat', '/broadcastings/tvformats'), new BRoute('broadcastings-page.tvformat detail')]));
  }

  ngOnDestroy() {
    if (this.refreshTvFormatSubscription) { this.refreshTvFormatSubscription.unsubscribe(); }
    if (this.getTvFormatDeviceInfoSubscription) { this.getTvFormatDeviceInfoSubscription.unsubscribe(); }
    if (this.getTvFormatLayoutsSubscription) { this.getTvFormatLayoutsSubscription.unsubscribe(); }
    if (this.getTvFormatDesksSubscription) { this.getTvFormatDesksSubscription.unsubscribe(); }
  }
}
